import { agent } from '../utils/agent'
const API_URL = process.env.REACT_APP_API_URL

const getAnnouncements = async (offset = 0, itemsPerPage = 0, activePage = 0, params = []) => {
  const response = await agent.get(
    `${API_URL}admin-announcements/listing?offset=${offset}&limit=${itemsPerPage}&page=${activePage}&${params}`,
  )
  return response.data
}

const saveAnnouncement = async (data) => {
  const response = await agent.post(API_URL + 'admin-announcements/save-announcement', data)
  return response.data
}

const editAnnouncement = async (data) => {
  const response = await agent.post(API_URL + 'admin-announcements/edit-announcement', data)
  return response.data
}

const getAnnouncementDetail = async (id) => {
  const response = await agent.get(`${API_URL}admin-announcements/announcement-details/${id}`)
  return response.data
}

const deleteAnnouncement = async (data) => {
  const response = await agent.post(API_URL + 'admin-announcements/delete-announcement', data)
  return response.data
}

const updateStatus = async (id, status) => {
  const response = await agent.get(`${API_URL}admin-announcements/update-status/${id}/${status}`)
  return response.data
}

const AdminAnnouncementService = {
  getAnnouncements,
  saveAnnouncement,
  deleteAnnouncement,
  getAnnouncementDetail,
  editAnnouncement,
  updateStatus,
}

export default AdminAnnouncementService
